export enum TagsRoutes {
	TAGS = "/yt/tags/",
}
